module.exports = __webpack_public_path__ + "img/2S.e8c6e1db.svg";